import { useEffect } from 'react';
import { SEO_CONFIG, SITE_URL } from '../../config/seo';

const SCRIPT_ID = 'nexting-structured-data';

function buildStructuredData() {
  const siteUrl = SITE_URL.replace(/\/$/, '');
  const { business } = SEO_CONFIG;

  return [
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: siteUrl,
      name: SEO_CONFIG.siteName,
      description: SEO_CONFIG.defaultDescription,
      inLanguage: SEO_CONFIG.language,
      publisher: { '@id': `${siteUrl}/#organization` },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      '@id': `${siteUrl}/#organization`,
      name: business.name,
      legalName: business.legalName,
      url: siteUrl,
      logo: `${siteUrl}/images/logo.png`,
      image: `${siteUrl}${SEO_CONFIG.defaultImage}`,
      description: business.description,
      email: business.email,
      telephone: business.telephone,
      address: {
        '@type': 'PostalAddress',
        streetAddress: business.address.streetAddress,
        addressLocality: business.address.addressLocality,
        addressRegion: business.address.addressRegion,
        postalCode: business.address.postalCode,
        addressCountry: business.address.addressCountry,
      },
      areaServed: {
        '@type': 'Country',
        name: business.areaServed,
      },
      sameAs: [],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'ProfessionalService',
      '@id': `${siteUrl}/#localbusiness`,
      name: business.name,
      image: `${siteUrl}${SEO_CONFIG.defaultImage}`,
      url: siteUrl,
      telephone: business.telephone,
      email: business.email,
      priceRange: business.priceRange,
      description: business.description,
      address: {
        '@type': 'PostalAddress',
        streetAddress: business.address.streetAddress,
        addressLocality: business.address.addressLocality,
        addressRegion: business.address.addressRegion,
        postalCode: business.address.postalCode,
        addressCountry: business.address.addressCountry,
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: business.geo.latitude,
        longitude: business.geo.longitude,
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '08:00',
          closes: '18:00',
        },
      ],
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Services d\'ingénierie du bâtiment',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Études structurelles',
              description:
                'Conception et dimensionnement des structures béton armé, métalliques et mixtes.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Suivi et pilotage de chantier',
              description:
                'Supervision technique et organisationnelle des travaux sur site.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Études d\'exécution',
              description:
                'Plans d\'exécution, synthèse technique et coordination de chantier.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Optimisation des coûts de construction',
              description:
                'Solutions techniques pour maîtriser le budget sans compromettre la qualité.',
            },
          },
        ],
      },
    },
  ];
}

export default function StructuredData() {
  useEffect(() => {
    let script = document.getElementById(SCRIPT_ID);
    if (!script) {
      script = document.createElement('script');
      script.id = SCRIPT_ID;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(buildStructuredData());

    return () => {
      const existing = document.getElementById(SCRIPT_ID);
      if (existing) existing.remove();
    };
  }, []);

  return null;
}
